import React from 'react';
import PageLayout from '../components/PageLayout';

const DeleteAccount = () => (
  <PageLayout title="Delete Account">
    <p>We're sorry to see you go. If you'd like to delete your Chakna Point account and all associated data, please follow the instructions below.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>How to Delete Your Account</h2>
    <h3 style={{ fontSize: 15, fontWeight: 600, marginTop: 16, marginBottom: 8, color: '#2D1A00' }}>Option 1: From the App</h3>
    <ol style={{ paddingLeft: 20 }}>
      <li>Open the Chakna Point app</li>
      <li>Go to Profile → Settings</li>
      <li>Tap "Delete Account"</li>
      <li>Confirm your decision</li>
      <li>Your account will be scheduled for deletion</li>
    </ol>

    <h3 style={{ fontSize: 15, fontWeight: 600, marginTop: 16, marginBottom: 8, color: '#2D1A00' }}>Option 2: Via Email</h3>
    <p>Send an email to <strong>support@chaknapoint.com</strong> with:</p>
    <ul style={{ paddingLeft: 20 }}>
      <li>Subject: "Account Deletion Request"</li>
      <li>Your registered phone number</li>
      <li>Reason for deletion (optional)</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>What Happens When You Delete Your Account</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>Your personal information (name, phone, email) will be permanently deleted.</li>
      <li>Your order history will be anonymized.</li>
      <li>Any wallet balance will be forfeited.</li>
      <li>Active orders (if any) will be completed before deletion.</li>
      <li>This action is irreversible — you cannot recover your account after deletion.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>Data Deletion Timeline</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>Account deactivation: Immediate</li>
      <li>Personal data deletion: Within 30 days</li>
      <li>Backup data purge: Within 90 days</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>Need Help?</h2>
    <p>If you're facing issues or have concerns, please reach out to us before deleting your account. We'd love to help resolve any problems.</p>
    <p><strong>Email:</strong> support@chaknapoint.com<br /><strong>Phone:</strong> +91 98765 43210</p>
  </PageLayout>
);

export default DeleteAccount;
